import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { ActivadesRegimenHEDTO, ActividadPlanbyServidorHEDTO, DataActividadSave, DetalleActividadPlanHEDTO, DetalleModificacionPlanificacionHE, DetallePlanificacionHE, DetalleServidoresPlanificacionHE, DetalleServidorPlanHEDTO, PresupuestoPlanificacionHistoricoHEDTO, SolicitudReversoDTO } from "./TypesPlanificacionHE";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { downloadExcelReport } from "helpers/downloadExcelReport";


export async function ObtenerInformacionHistorialPresupuestoPlanificacionHE(anio: number) {
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/InformacionPresupuestoPlanificacionHorasExtras/${anio}`;

    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: PresupuestoPlanificacionHistoricoHEDTO = { 
        anio: 0,
        detalleRegimenPresupuestobyMes: []        
    }

    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        infoResponse = hadleAxiosErrorResponse<PresupuestoPlanificacionHistoricoHEDTO>(error)
    }

    return infoResponse;

}

export async function ObtenerInformacionPlanificacionHE(anio: number, mes: number, puedeRealizarAccion: boolean) {
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/InformacionGeneralPlanificacionHorasExtras/${anio}/${mes}/${puedeRealizarAccion}`;

    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: DetallePlanificacionHE = { 
        puedeRealizarAccion: false,
        anio: 0,
        mes: 0,
        nombreMes: "",
        diaMax: 0,
        idPlanifUnidad: 0,
        idSolReverso: 0,
        estadoPlanificacion: "",
        refPlanifUnidad: "",
        fechaMaxima: new Date(),
        gruposActividad: [],
        listadoServidores: [],
        listadoServidoresOtrasUnidades: [],
        listadoRegimenLaborales: [],
        listadoRegimenLaboralesPlan: [],
        paramsHorasMesPlanificacionHE: [],
        novedadesServidores: [],
        detalleActividadPlanHEDTOs: [],
        informacionAprobador: {
            informacionAprobador: {
                nombres: '',
                apellidos: '',
                email: '',
                idpersona: 0,
                tipoAprobador: -1,
                TipoAprobadorString: '',
                idEstructuraOrganica: 0,
                idEstructuraOrganicaAprobacion: 0,
            },
            mensaje: ''
        },
        nombreUnidadAprobacion: ''
    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
            
        }
    }

    return infoResponse;

}




export async function ObtenerInformacionModificadaPlanificacionHE() {
    const url = configData.SERVER_URL + "PlanificacionHorasExtras/InformacionModificadaPlanificacionHorasExtras";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: DetalleModificacionPlanificacionHE = { 
        listadoServidores: [],
        detalleActividadPlanHEDTOs: [],
        listadoServidoresOtrasUnidades: []
    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
            
        }
    }

    return infoResponse;

}


export async function ObtenerInformacionServidorHE(identificacion: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuesta: ResponseRequestGeneric<DetalleServidoresPlanificacionHE> = {
        status: -1
    };

    try {
        const url = configData.SERVER_URL + `PlanificacionHorasExtras/DetalleServidorHE/${identificacion}`;
        
        const responseAxios = await axios.get(url, {
            headers: authHeaderWithToken(infoUsuario.token)
        })

        var data: DetalleServidoresPlanificacionHE = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleServidoresPlanificacionHE>(error)
    }

    return respuesta
}

export async function ObtenerActividadesByRegimenHE(idRegimen:number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/ActividadesByRegimen/${idRegimen}`;
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: ActivadesRegimenHEDTO[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}

export async function ObtenerActividadesByServidorHE(idServidor:number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + `PlanificacionHorasExtras/ActividadesPlanificadasByServidor/${idServidor}`;
    try {
        const respuesta = await axios.get(url, {
            headers: authHeaderWithToken(infoUsuario.token)
        })
        const dataResponse: ActividadPlanbyServidorHEDTO[] = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status }
        }
    }

    return respuestaResponse;
}


export async function GuardarPlanificacionbyActividad(planificacion: DataActividadSave) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/GuardarPlanificacionbyActividad`;
    try {
        const respuesta = await axios.post(url, planificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;
        
        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function EditarPlanificacionbyActividad(planificacion: DataActividadSave) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/EditarPlanificacionbyActividad`;
    try {
        const respuesta = await axios.post(url, planificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;
        
        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function EliminarPlanificacionbyActividad(idActividad: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/EliminarPlanificacionbyActividad/${idActividad}`;
    try {
        const respuesta = await axios.post(url, {}, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;
        
        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}



export async function GuardarPlanificacionbyServidor(planificacion: DetalleServidorPlanHEDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleServidoresPlanHEDTOs: DetalleServidoresPlanificacionHE[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleServidoresPlanHEDTOs }

    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/GuardarPlanificacionbyServidor`;
    try {
        const respuesta = await axios.post(url, planificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleServidoresPlanHEDTOs = respuesta.data;
        
        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleServidoresPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function GuardarPlanificacionParcialmente(planificacion: DetalleServidoresPlanificacionHE[]) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/GuardarPlanificacionParcialmente`;
    try {
        const respuesta = await axios.post(url, planificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;
        
        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function ObtenerVistaPreviaFormularioPlanificacionHE(planificacion: DetalleServidoresPlanificacionHE[]) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = configData.SERVER_URL + "PlanificacionHorasExtras/GuardarPlanificacion/VistaPreviaFormularioSolicitud" ;
    try {
        const respuesta = await axios.post(URL, planificacion,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}

export async function GuardarPlanificacionUnidadHE(datosRequest: FormData) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }


    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/GuardarPlanificacionUnidad`;
    try {
        const respuesta = await axios.post(url, datosRequest, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;
        
        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}


export async function SolicitarReversoPlanificacion(idPlanificacion: number, datosRechazar: SolicitudReversoDTO) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    const url = `${configData.SERVER_URL}PlanificacionHorasExtras/SolicitarReversoPlanificacion/${idPlanificacion}`;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.post(url, datosRechazar,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        resultado = { status: respuesta.status, dataResponse: respuesta.data }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}


export async function ObtenerReporteExcelResumenPlanificacion(anio:number, mes:number) {
    const url = `PlanificacionHorasExtras/ReporteExcelPlanificacion/${anio}/${mes}`;
    //const URLCOMPLETA = `${URL_REPORTE_EXCEL_RESUMEN_PROYECCION}`
    await downloadExcelReport(url, "REPORTE PLANIFICACIÓN UNIDAD.xlsx")
}

export const calcularValorHorabyRMU = (rmu: number) => {
    const valorHora = parseFloat((rmu / 240).toFixed(2));
    return valorHora;
};

export const calcularValorHoraSuplementariasbyRMU = (idRegimen: number, valorHora: number) => {
    let valorHoraSuplementaria = 0;
    if (idRegimen === 9) {
        valorHoraSuplementaria = parseFloat((valorHora * 1.5).toFixed(2));
    } else if (idRegimen === 7) {
        valorHoraSuplementaria = parseFloat((valorHora * 1.25).toFixed(2));
    }
    return valorHoraSuplementaria;
};


export const calcularValorHoraExtraordinariabyRMU = (idRegimen: number, valorHora: number) => {
    let valorHoraExtraordinaria = 0;
    if (idRegimen === 9 || idRegimen === 7) {
        valorHoraExtraordinaria = parseFloat((valorHora * 2).toFixed(2));
    }
    return valorHoraExtraordinaria;
};

export const calcularValorTotalSuplementarias = (valorHoraSuplementaria: number, numHora: number | undefined) => {
    let valorTotalHoraSuplementaria = 0;
    if(numHora !== undefined){
        valorTotalHoraSuplementaria = parseFloat((valorHoraSuplementaria * numHora).toFixed(2));
    }
    return valorTotalHoraSuplementaria;
};


export const calcularValorTotalExtraordinarias = (valorHoraExtraordinaria: number, numHora: number | undefined) => {
    let valorTotalHoraExtraordinaria = 0;
    if(numHora !== undefined){
        valorTotalHoraExtraordinaria = parseFloat((valorHoraExtraordinaria * numHora).toFixed(2));
    }
    
    return valorTotalHoraExtraordinaria;
};

export const calcularValorTotalHora = (valorTotalHoraSuplementaria: number, valorTotalHoraExtraordinaria: number) => {
    let valorTotal = 0;
    valorTotal = parseFloat((valorTotalHoraSuplementaria + valorTotalHoraExtraordinaria).toFixed(2));
    return valorTotal;
};